import styled from "@emotion/styled";

export const Cell = styled.div({
    paddingTop: 20,
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    lineHeight: "36px",
});

export const Line = styled.div({
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    height: "32px",
});
